import Helpers from "./helpers";

export default {
  getText: function (props, datum, index) {
    if (datum.label !== undefined) {
      return datum.label;
    }
    return Array.isArray(props.labels) ? props.labels[index] : props.labels;
  },
  getVerticalAnchor: function (props, datum) {
    var sign = datum._y >= 0 ? 1 : -1;
    var labelStyle = props.style && props.style.labels || {};
    if (datum.getVerticalAnchor || labelStyle.verticalAnchor) {
      return datum.getVerticalAnchor || labelStyle.verticalAnchor;
    } else if (!props.horizontal) {
      return sign >= 0 ? "end" : "start";
    } else {
      return "middle";
    }
  },
  getTextAnchor: function (props, datum) {
    var style = props.style,
        horizontal = props.horizontal;

    var sign = datum._y >= 0 ? 1 : -1;
    var labelStyle = style && style.labels || {};
    if (datum.getVerticalAnchor || labelStyle.verticalAnchor) {
      return datum.getVerticalAnchor || labelStyle.verticalAnchor;
    } else if (!horizontal) {
      return "middle";
    } else {
      return sign >= 0 ? "start" : "end";
    }
  },
  getAngle: function (props, datum) {
    var labelStyle = props.style && props.style.labels || {};
    return datum.angle || labelStyle.angle;
  },
  getPadding: function (props, datum) {
    var horizontal = props.horizontal,
        style = props.style,
        active = props.active;

    var labelStyle = style.labels || {};
    var defaultPadding = Helpers.evaluateProp(labelStyle.padding, datum, active) || 0;
    var sign = datum._y < 0 ? -1 : 1;
    return {
      x: horizontal ? sign * defaultPadding : 0,
      y: horizontal ? 0 : sign * defaultPadding
    };
  },
  getPosition: function (props, datum) {
    var horizontal = props.horizontal,
        polar = props.polar;

    var _Helpers$scalePoint = Helpers.scalePoint(props, datum),
        x = _Helpers$scalePoint.x,
        y = _Helpers$scalePoint.y;

    var padding = this.getPadding(props, datum);
    if (!polar) {
      return {
        x: horizontal ? y + padding.x : x + padding.x,
        y: horizontal ? x + padding.y : y - padding.y
      };
    } else {
      var polarPadding = this.getPolarPadding(props, datum);
      return {
        x: x + polarPadding.x,
        y: y + polarPadding.y
      };
    }
  },
  getPolarPadding: function (props, datum) {
    var active = props.active,
        style = props.style;

    var degrees = this.getDegrees(props, datum);
    var labelStyle = style.labels || {};
    var padding = Helpers.evaluateProp(labelStyle.padding, datum, active) || 0;
    var angle = Helpers.degreesToRadians(degrees);
    return {
      x: padding * Math.cos(angle), y: -padding * Math.sin(angle)
    };
  },
  getLabelPlacement: function (props) {
    var labelComponent = props.labelComponent,
        labelPlacement = props.labelPlacement,
        polar = props.polar;

    var defaultLabelPlacement = polar ? "perpendicular" : "vertical";
    return labelPlacement ? labelPlacement : labelComponent.props && labelComponent.props.labelPlacement || defaultLabelPlacement;
  },
  getPolarOrientation: function (degrees) {
    if (degrees < 45 || degrees > 315) {
      // eslint-disable-line no-magic-numbers
      return "right";
    } else if (degrees >= 45 && degrees <= 135) {
      // eslint-disable-line no-magic-numbers
      return "top";
    } else if (degrees > 135 && degrees < 225) {
      // eslint-disable-line no-magic-numbers
      return "left";
    } else {
      return "bottom";
    }
  },
  getPolarTextAnchor: function (props, degrees) {
    var labelPlacement = this.getLabelPlacement(props);
    if (labelPlacement === "perpendicular" || labelPlacement === "vertical" && (degrees === 90 || degrees === 270)) {
      return "middle";
    }
    return degrees <= 90 || degrees > 270 ? "start" : "end";
  },
  getPolarVerticalAnchor: function (props, degrees) {
    var labelPlacement = this.getLabelPlacement(props);
    var orientation = this.getPolarOrientation(degrees);
    if (labelPlacement === "parallel" || orientation === "left" || orientation === "right") {
      return "middle";
    }
    return orientation === "top" ? "end" : "start";
  },
  getPolarAngle: function (props, baseAngle) {
    var labelPlacement = props.labelPlacement,
        datum = props.datum;

    if (!labelPlacement || labelPlacement === "vertical") {
      return 0;
    }
    var degrees = baseAngle !== undefined ? baseAngle : this.getDegrees(props, datum);
    var sign = degrees > 90 && degrees < 180 || degrees > 270 ? 1 : -1;
    var angle = void 0;
    if (degrees === 0 || degrees === 180) {
      angle = 90;
    } else if (degrees > 0 && degrees < 180) {
      angle = 90 - degrees;
    } else if (degrees > 180 && degrees < 360) {
      angle = 270 - degrees;
    }
    var labelRotation = labelPlacement === "perpendicular" ? 0 : 90;
    return angle + sign * labelRotation;
  },
  getDegrees: function (props, datum) {
    var _Helpers$getPoint = Helpers.getPoint(datum),
        x = _Helpers$getPoint.x;

    return Helpers.radiansToDegrees(props.scale.x(x));
  },
  getProps: function (props, index) {
    var scale = props.scale,
        data = props.data,
        style = props.style,
        horizontal = props.horizontal,
        polar = props.polar;

    var datum = data[index];
    var degrees = this.getDegrees(props, datum);
    var textAnchor = polar ? this.getPolarTextAnchor(props, degrees) : this.getTextAnchor(props, datum);
    var verticalAnchor = polar ? this.getPolarVerticalAnchor(props, degrees) : this.getVerticalAnchor(props, datum);
    var angle = this.getAngle(props, datum);
    var text = this.getText(props, datum, index);
    var labelPlacement = this.getLabelPlacement(props);

    var _getPosition = this.getPosition(props, datum),
        x = _getPosition.x,
        y = _getPosition.y;

    return {
      angle: angle, data: data, datum: datum, horizontal: horizontal, index: index, polar: polar, scale: scale, labelPlacement: labelPlacement,
      text: text, textAnchor: textAnchor, verticalAnchor: verticalAnchor, x: x, y: y, style: style.labels
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/es/victory-util/label-helpers.js
// module id = 395
// module chunks = 0